import Vue from 'vue'
import computed from 'vue'
import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const all_permission = "*:*:*"; // 全部权限

    setTimeout(()=>{
      const permissions = store.getters && store.getters.getPermissions // 用户拥有的权限标识的数组
      console.log('所有权限数据',permissions);
      
      if (value && value instanceof Array && value.length > 0) {
        // 判断是否有权限
        const permissionFlag = value
        const hasPermissions = permissions.some(permission => {
          return permissionFlag.includes(permission)
        })
        // 如果没有权限，则移除元素
        if (!hasPermissions) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      } else {
        throw new Error('请设置操作权限标签值')
      }

    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/hasPermi.js